"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PositionData = require("./PositionData");
Object.keys(_PositionData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PositionData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PositionData[key];
    }
  });
});
var _Placement = require("./Placement");
Object.keys(_Placement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Placement[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Placement[key];
    }
  });
});
//# sourceMappingURL=index.js.map